// ==================================================================================================
//  TECH DEBT: THIS CODE WAS TAKEN FROM https://github.com/tombolaltd/javascript-arcade
//             AND SHOULD BE REPLACED WITH A SUITABLE NPM PACKAGE ONCE AVAILABLE
// ==================================================================================================
import { Container } from 'pixi.js';

abstract class Slide extends Container {
  constructor() {
    super();
  }

  public abstract initSlide(slideWidth: number, slideHeight: number): void;
  public abstract handleOrientationChange(slideWidth: number, slideHeight: number, yPosition: number): void;
}

export { Slide };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_components/how-to-play/_domain/slider/slide.ts